module.exports = __webpack_public_path__ + "media/images/card_jcb-35a2ab0f2e0f48e117d3ed8494b4e0f0.jpg";